module.exports = __webpack_public_path__ + "static/media/是否有去空曠處避難.bc45016c.png";